import { Link } from "react-router-dom";

/**
 * Warm-black cinematic footer — matches CinematicHomePage aesthetic.
 * Sparse editorial layout, hairline dividers, champagne accents,
 * italic Fraunces brand mark.
 */
const CinematicFooter = () => (
  <footer className="bg-[#0D0D0D] text-[#F5F1EA] pt-24 pb-14 cinematic-grain relative" data-testid="footer">
    <div className="container-premium relative">
      <div className="grid md:grid-cols-12 gap-12 md:gap-16">
        {/* Brand */}
        <div className="md:col-span-4">
          <div className="cinematic-serif-italic text-[#F5F1EA] text-3xl leading-none mb-2">
            Beach Escape
          </div>
          <div className="chapter-label text-white/60 mb-8">Indialantic · Florida</div>
          <p className="cinematic-body text-sm max-w-xs">
            Premium furnished housing for extended stays in Indialantic, Florida.
            Ninety-day minimum. Direct-owner booking.
          </p>
          <div className="mt-10 chapter-label text-white/50">
            2161 Todd Ln, Indialantic, FL 32903
          </div>
        </div>

        {/* Housing Types */}
        <div className="md:col-span-2">
          <div className="chapter-label mb-6 text-white/60">Housing</div>
          <nav className="flex flex-col gap-3">
            {[
              ["/monthly-rates", "Monthly Rates"],
              ["/corporate-housing", "Corporate"],
              ["/snowbird-rentals", "Snowbird"],
              ["/traveling-nurse-housing", "Travel Nurse"],
            ].map(([to, label]) => (
              <Link
                key={to}
                to={to}
                className="cinematic-serif text-[#F5F1EA] text-base hover:text-[#C4A570] transition-colors duration-300"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        {/* Areas */}
        <div className="md:col-span-3">
          <div className="chapter-label mb-6 text-white/60">Areas</div>
          <nav className="flex flex-col gap-3">
            {[
              ["/indialantic-beach-rental", "Indialantic"],
              ["/melbourne-beach-house-rental", "Melbourne Beach"],
              ["/satellite-beach-rental", "Satellite Beach"],
              ["/space-coast-monthly-rental", "Space Coast"],
              ["/brevard-county-furnished-rental", "Brevard County"],
              ["/gallery", "Photo Gallery"],
              ["/faq", "FAQ"],
            ].map(([to, label]) => (
              <Link
                key={to}
                to={to}
                className="cinematic-serif text-[#F5F1EA] text-base hover:text-[#C4A570] transition-colors duration-300"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        {/* Contact */}
        <div className="md:col-span-3">
          <div className="chapter-label mb-6 text-white/60">Contact Direct</div>
          <div className="space-y-6">
            <a href="tel:4074509182" className="block group" data-testid="footer-call">
              <div className="chapter-label text-white/40 text-[9px] mb-1">Call or Text</div>
              <div className="cinematic-serif text-2xl text-[#F5F1EA] group-hover:text-[#C4A570] transition-colors">
                (407) 450-9182
              </div>
            </a>
            <a
              href="mailto:RAEVenturesLLC@gmail.com?subject=Beach%20Escape%20FL%20-%20Extended%20Stay%20Inquiry"
              className="block group"
              data-testid="footer-email"
            >
              <div className="chapter-label text-white/40 text-[9px] mb-1">Email</div>
              <div className="cinematic-serif text-lg text-[#F5F1EA] group-hover:text-[#C4A570] transition-colors break-all">
                RAEVenturesLLC@gmail.com
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="mt-24 pt-10 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <p className="chapter-label text-white/40">
          © {new Date().getFullYear()} Beach Escape FL · All rights reserved
        </p>
        <p className="chapter-label text-white/40">
          Ninety-day minimum · Direct owner booking
        </p>
      </div>
    </div>
  </footer>
);

export default CinematicFooter;
